export interface CaseStudyStat {
  label: string;
  value: string;
}

export interface CaseStudy {
  id: string;
  slug: string;
  title: string;
  challenge: string;
  solution: string;
  outcomeStats: CaseStudyStat[];
  publishedAt: string; // ISO date
}

// TODO(content): populate once ZenFresh has a real, auditable B2B case
// study to publish. Deliberately empty — this ticket's own AC frames the
// audience as an investor/B2B partner assessing "track record with data,
// not just anecdotes," explicitly contrasting itself against the
// composite-persona testimonials in testimonials.ts. A specific quantified
// claim ("35% reduction in spoilage") implies a real, auditable client
// relationship a specific person could ask about — the same class of claim
// this project has consistently declined to fabricate (press mentions, app
// ratings, real harbour names). CaseStudyIndex.tsx shows a "coming soon"
// state while this is empty.
export const CASE_STUDIES: CaseStudy[] = [];
